module.exports = __webpack_public_path__ + "img/stat_04_icon.7838f042.png";